import { getRequiredFields } from 'helpers/getRequiredFields';
import { TFunction } from 'react-i18next';
import * as yup from 'yup';

import { CATEGORY_TYPE } from 'models/documents.model';

import { CertificateTypeConfig } from '../hooks/useCategoryConfig';

export const getValidationSchema = (
  type: CATEGORY_TYPE,
  config: CertificateTypeConfig,
  t: TFunction
) => {
  const numberRequired = yup
    .number()
    .typeError(t('warning.number'))
    .required(t('warning.required'));

  const stringRequired = yup.string().required(t('warning.required'));

  const requiredFields = getRequiredFields(config.formFields, t);

  if (config.uploadPDFLabel) {
    requiredFields.additionalCertificate = yup.mixed().required(t('warning.required'));
  }

  switch (type) {
    case CATEGORY_TYPE.CHEMISTRY:
    case CATEGORY_TYPE.BATTERY_CELLS:
    case CATEGORY_TYPE.BATTERY_PACKS:
    case CATEGORY_TYPE.BATTERY_TECH_REVIEW:
    case CATEGORY_TYPE.BATTERY_PACKS_REPAIR:
    case CATEGORY_TYPE.BATTERY_REPURPOSE:
    case CATEGORY_TYPE.BATTERY_PACKS_RECYCLING:
    case CATEGORY_TYPE.BATTERY_WASTE:
      return yup.object(requiredFields);

    case CATEGORY_TYPE.CERTIFICATE:
    default:
      return yup.object({
        ...requiredFields,
        percentRecycled: numberRequired,
        components: yup.array().of(
          yup.object({
            componentPassportId: yup.string(),
            supplierId: stringRequired,
            supplierName: stringRequired,
            componentName: stringRequired,
            componentId: stringRequired,
            itemId: yup.string(),
            batchNumber: stringRequired,
            countryOfOrigin: stringRequired,
            region: yup.string(),
            factory: yup.string(),
            percentShare: numberRequired
              .min(0, t('warning.belowZero'))
              .max(100, t('warning.overHundred')),
            percentRecycled: numberRequired
              .min(0, t('warning.belowZero'))
              .max(100, t('warning.overHundred')),
          })
        ),
      });
  }
};
